import React, {useCallback, useMemo, useState} from "react";
import {ConfigProvider, Tag, Spin, Dropdown, Menu} from "antd";
import {StringBuilder} from "../../AppUtils.js";
import {useRequest} from "../../utils/hooks.jsx";
import {OrderPackageDetails} from "../../event/OrderInformationCard/Sections/OrderPackageDetails.jsx";
import "./delivery-info-page.css";
import {
    DeliveryProviderDeliveryStatus,
    DeliveryProviderDeliveryStatusToText,
    DeliveryStatusToColor
} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {SystemIdToIcon} from "../../admin/AdminOrders/consts.jsx";
import {SourceDeliverySection} from "./SourceDeliverySection.jsx";
import {DestinationDeliverySection} from "./DestinationDeliverySection.jsx";
import {DeliveryStatusHistorySection} from "./DeliveryStatusHistorySection.jsx";
import {changeDeliveryDriver, changeDeliveryStatus} from "../../api/deliveries/deliveries.js";
import {StyledButton} from "../../components/StyledButton.jsx";
import {DownOutlined} from "@ant-design/icons";
import classNames from "classnames";
import {keyBy} from "lodash";
import "./delivery-info-page.css";
import {deliveryProviderDriversProjection} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {isEmpty} from "lodash";
import {OrderActions} from "../../event/OrderActionList/OrderActions.jsx";

export const DeliveryInfoPage = ({match}) => {
    const {deliveryId} = match.params;
    const [loading, setLoading] = useState(false);

    const [drivers = [], isLoadingDrivers] = useRequest(
        "/api/deliveryProviders/myDrivers",
        "POST",
        {
            projection: deliveryProviderDriversProjection
        },
        []
    );

    const driverIdToDriver = useMemo(() => keyBy(drivers, driver => driver?.driverId), [drivers]);

    const [deliveryInfo = {}, isLoadingDeliveryInfo, error, fetchDeliveryInfo] = useRequest(
        `/api/deliveryProviders/deliveries/${deliveryId}`,
        "GET",
        null,
        [deliveryId],
        !!deliveryId,
        null,
        {
            delivery: {},
            subDeliveries: [],
            order: {}
        }
    );

    const onChangeDeliveryDriver = useCallback(
        async driverId => {
            setLoading(true);
            const response = await changeDeliveryDriver(deliveryInfo?.delivery?.deliveryId, driverId);
            if (response?.error) {
                setLoading(false);
                return;
            }

            setLoading(false);
            fetchDeliveryInfo();
        },
        [deliveryInfo?.delivery?.deliveryId, fetchDeliveryInfo]
    );

    const onDeliveryStatusChange = useCallback(
        async (deliveryId, status, statusMessage) => {
            try {
                await changeDeliveryStatus(deliveryId, status, statusMessage);
                fetchDeliveryInfo();
                return true;
            } catch (error) {
                return false;
            }
        },
        [fetchDeliveryInfo]
    );

    const actions = [
        {
            text: ({driverId}) => (driverId ? driverIdToDriver?.[driverId]?.name : "ציוות שליח"),
            type: "dropdown",
            color: !isLoadingDrivers ? "blue" : "grey",
            loading: loading || isLoadingDrivers,
            options: drivers?.map(({driverId, name}) => ({label: name, key: driverId})),
            onClick: onChangeDeliveryDriver
        }
    ];

    return (
        <div className="delivery-info-page">
            {isEmpty(deliveryInfo?.delivery) ? (
                <Spin />
            ) : (
                <ConfigProvider direction="rtl">
                    <div className="header-container">
                        <span className="title">
                            {new StringBuilder("הזמנה").append(deliveryInfo?.delivery?.proposalId).toString()}
                        </span>
                        <Tag
                            className="status-tag"
                            style={{
                                color: DeliveryStatusToColor?.[deliveryInfo?.delivery?.status]?.[0],
                                backgroundColor: DeliveryStatusToColor?.[deliveryInfo?.delivery?.status]?.[1]
                            }}>
                            {DeliveryProviderDeliveryStatusToText[deliveryInfo?.delivery?.status]}
                        </Tag>

                        <img
                            className="system-id-icon"
                            src={SystemIdToIcon[deliveryInfo?.order.systemId]}
                            alt="systemId_icon"
                        />
                    </div>
                    <div className="delivery-info-container">
                        <SourceDeliverySection
                            deliveryInfo={deliveryInfo}
                            onDeliveryStatusChange={onDeliveryStatusChange}
                        />

                        <DestinationDeliverySection
                            deliveryInfo={deliveryInfo}
                            onDeliveryStatusChange={onDeliveryStatusChange}
                        />
                        {deliveryInfo?.delivery?.statusHistory?.length > 0 && (
                            <DeliveryStatusHistorySection deliveryInfo={deliveryInfo} />
                        )}
                    </div>

                    {!!(
                        deliveryInfo?.delivery?.status === DeliveryProviderDeliveryStatus.failed &&
                        !!deliveryInfo?.delivery?.statusMessage
                    ) && (
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <span className="title" style={{color: "red"}}>
                                תיאור התקלה
                            </span>
                            <span>{deliveryInfo?.delivery?.statusMessage}</span>
                        </div>
                    )}

                    <div>
                        <span className="title">פרטי ההזמנה</span>
                        <OrderPackageDetails eventInfo={deliveryInfo?.order ?? {}} />
                    </div>
                    <OrderActions actions={actions} data={deliveryInfo?.delivery} />
                </ConfigProvider>
            )}
        </div>
    );
};
